package com.eladfinish.bible.contest.features.installTime.platform

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set
import kotlin.js.Date

/**
 * A website isn't installed, so the nearest thing to an install time is this browser's first
 * visit: recorded in `localStorage` the first time it is asked for, and returned from then on.
 * Clearing the site's data (or "Reset preferences") starts the count again, like a reinstall.
 *
 * There is no notion of an update the page could date either — every load serves the current
 * version — so the last update is reported as the first visit, i.e. "never updated since".
 */
actual class AppInstallInfoProvider {

    actual fun firstInstallTimeMillis(): Long? =
        try {
            localStorage[FIRST_VISIT_KEY]?.toLongOrNull()
                ?: Date.now().toLong().also { localStorage[FIRST_VISIT_KEY] = it.toString() }
        } catch (_: Throwable) {
            // Storage is blocked (some private-browsing modes): not supported here.
            null
        }

    actual fun lastUpdateTimeMillis(): Long? = firstInstallTimeMillis()

    private companion object {
        const val FIRST_VISIT_KEY = "first_visit_millis"
    }
}
